<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>分享配置</span>
          <clear-cache-apply />
          <sync-data />
        </div>

        <el-table :data="formData" border stripe>
          <el-table-column prop="type" label="分享配置最大次数">
            <template slot-scope="scope">
              <el-input v-model.number="scope.row.maxTimes" />
            </template>
          </el-table-column>
          <el-table-column prop="reward" label="赠送体力">
            <template slot-scope="scope">
              <el-input v-model.number="scope.row.reward" />
            </template>
          </el-table-column>
          <el-table-column prop="show" label="是否展示">
            <template slot-scope="scope">
              <el-select v-model.number="scope.row.show" placeholder="请选择">
                <el-option
                  v-for="item in statusType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column width="500px" prop="time" label="间隔时间">
            <template slot-scope="scope">
              <el-input v-model.number="scope.row.intervalTime" />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200px">
            <template slot-scope="scope">
              <el-button v-permisaction="['config:shareBase:del']" type="danger" @click="del(scope.row.id, scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 10px;text-align: center">
          <el-button v-permisaction="['config:shareBase:add']" type="primary" @click="add()">+</el-button>
          <el-button v-permisaction="['config:shareBase:add']" type="primary" @click="onSubmit()">保存</el-button>
        </div>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { delShareBaseCfg, getShareBaseCfgList, updateShareBaseCfg } from '@/api/config/share-base-cfg'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'

export default {
  name: 'ShareBase',
  components: { SyncData, ClearCacheApply },
  data() {
    return {
      statusType: [
        { label: '启用', value: 1 },
        { label: '禁用', value: 0 }
      ],
      formData: [{
        maxTimes: 0,
        reward: 0,
        intervalTime: 0,
        show: 1
      }]
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    onSubmit() {
      for (const i in this.formData) {
        const _data = this.formData[i]
        console.log('data', _data)
        if (_data.maxTimes <= 0) {
          this.msgError('配置最大次数不能小于等于0')
          return
        }

        if (_data.reward <= 0) {
          this.msgError('奖励不能小于等于0')
          return
        }
        if (_data.intervalTime < 0) {
          this.msgError('配置间隔时间不能小于0')
          return
        }
      }

      const data = JSON.stringify(this.formData)
      console.log('data', data)
      updateShareBaseCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getShareBaseCfgList().then(res => {
        this.formData = res.data.list
      })
    },
    add() {
      this.formData.push({
        maxTimes: 0,
        reward: 0,
        intervalTime: 0,
        show: 1
      })
    },
    del(id, index) {
      if (id > 0) {
        this.$confirm('是否确认删除数据项?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delShareBaseCfg({ 'id': id }).then(res => {
            this.getTables()
          })
        })
      } else {
        this.formData = this.formData.filter((item, key) => {
          return index !== key
        })
      }
    }
  }
}
</script>

<style scoped>
</style>
